// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"FeedbackModal_modalBackdrop__k5Xt0","modal":"FeedbackModal_modal__1JPJP","buttonRow":"FeedbackModal_buttonRow__GqjFv"};